import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnMenuMore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.ExtraBold}
      d="M5 12h0M12 12h0M19 12h0"
    />
  </svg>
);
export default DawnMenuMore;
